import { TextField } from "@material-ui/core";
import styles from "./SizeAndWeightStyles.module.css";
import WrappedKeyboardDateTimePicker from "../../WrappedKeyboardDateTimePicker";
import AddressWithAlertAndHmi from "../../AddressWithAlertAndHmi";
import SingleDropDown from "../../SingleDropDown";
import MultiDropDownObjects from "../../MultiDropDownObjects";
import NumberField from "./NumberFields/NumberFields";
import { useStyles } from "../../../Styles/styles";
import { useContext, useEffect, useRef, useState } from "react";
import { SetupContext } from "../../../Contexts/SetupContext";
import CollapsingHeader from "./CollapsingHeader/CollapsingHeader";
import CheckboxWithLabel from "../../CheckboxWithLabel";
import Required from "./Required/Required";
import CustomAutoComplete from "../../CustomAutoComplete";
import { parseDateFlexible } from "../../../utils/utils";

const InspectionSection = ({
  nightMode,
  dispatch,
  handleChange,
  state,
  incidentId,
  disabled,
  userRoles,
  handleDateChange,
  setPausePolling,
  missingFields,
  ...props
}) => {
  const classes = useStyles();
  const { setup } = useContext(SetupContext);
  const { setupLists } = setup || {};
  const {
    roadTypes,
    enforcementActivities,
    weightMethods: weightMethodss,
    stateHighways,
  } = setupLists || [];

  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const updateAddress = address => {
    const action = "UPDATE_PROPERTY";
    const payload = { property: "location", value: address };
    // dispatch({ type: 'UPDATE_PROPERTY', payload: { property: 'address', value: address } });
    handleChange(address, action, payload);
  };

  const {
    startedAt,
    location,
    roadType,
    stateHighway,
    escreen,
    enforcementActivity,
    weightMethods,
    sizePermitsChecked,
    weightPermitsChecked,
    cmvsChecked,
    cvsaDecalsIssued,
    supervisedInspections,
    lv1Inspections,
    lv2Inspections,
    lv3Inspections,
    lv4Inspections,
    lv5Inspections,
    lv6Inspections,
    lv7Inspections,
    lv8Inspections,
    lv1HazmatInspections,
    lv2HazmatInspections,
    lv4HazmatInspections,
    lv5HazmatInspections,
    driverViolations,
    vehicleViolations,
    numberOosDrivers,
    numberOosVehicles,
    numberVcvcsIssued,
    fineTotal,
    numberArrests,
  } = state || {};

  return (
    <div className={styles["flexColumn"]}>
      <div className={`${styles["flexRow"]}`}>
        <Required
          required={missingFields.some(field => field?.name === "startedAt")}
          message={
            missingFields.find(field => field?.name === "startedAt")?.error
          }
        >
          <WrappedKeyboardDateTimePicker
            dataCy="date-time-of-call-picker"
            clearable={true}
            showTodayButton={true}
            label="Date & Time Started"
            onFocus={() => setPausePolling(true)}
            onBlur={() => setPausePolling(false)}
            value={parseDateFlexible(startedAt)}
            onChange={(newValue, str, date) =>
              handleChange(date ?? "", "UPDATE_PROPERTY", {
                property: "startedAt",
                value: date ?? "",
              })
            }
            format="MM/DD/YYYY HH:mm"
            ampm={false}
            disabled={disabled}
          />
        </Required>
        <Required
          required={missingFields.some(field => field?.name === "location")}
          message={
            missingFields.find(field => field?.name === "location")?.error
          }
        >
          <AddressWithAlertAndHmi
            userRoles={userRoles}
            address={location}
            addressInputLabel={"Location\xa0Of\xa0Contact"}
            setAddress={updateAddress}
            validAlertName={"validAddressAlerts"}
            alertType={"address"}
            incidentId={incidentId}
            containerStyle={{}}
            onFocus={() => setPausePolling && setPausePolling(true)}
            onBlur={() => setPausePolling && setPausePolling(false)}
            showIntersection={true}
            showAlert={false}
            showHmi={true}
            disabled={disabled}
            {...props}
          />
        </Required>
        <Required
          required={missingFields.some(field => field?.name === "roadType")}
          message={
            missingFields.find(field => field?.name === "roadType")?.error
          }
        >
          <SingleDropDown
            title={"Road\xa0Type"}
            value={roadType || ""}
            options={roadTypes}
            handleChange={e => {
              handleChange(e.target.value, "UPDATE_PROPERTY", {
                property: "roadType",
              });
              handleChange("", "UPDATE_PROPERTY", { property: "stateHighway" });
            }}
            userRoles={userRoles}
            selectStyle={classes.singleDropDownPaddingAdjustment}
            inputLabel={inputLabel}
            labelWidth={labelWidth}
            disabled={disabled}
            {...props}
          />
        </Required>
        <Required
          required={missingFields.some(field => field?.name === "stateHighway")}
          message={
            missingFields.find(field => field?.name === "stateHighway")?.error
          }
        >
          <CustomAutoComplete
            title={"Highway"}
            options={
              stateHighways.filter(
                hwy => hwy.roadType?.name === roadType?.name
              ) || []
            }
            addMargin={true}
            value={stateHighway || null}
            stateName={"stateHighway"}
            updateFields={(value, stateName) =>
              handleChange(value, "UPDATE_PROPERTY", { property: stateName })
            }
            nameFormatter={false}
            minWidth={"150px"}
            userRoles={userRoles}
            disabled={!roadType || roadType?.name === "Municipal" || disabled}
            {...props}
          />
        </Required>
        <CheckboxWithLabel
          formStyle={classes.formControl}
          checked={escreen}
          onChange={e =>
            handleChange(e.target.checked, "UPDATE_PROPERTY", {
              property: "escreen",
            })
          }
          stateName={"escreen"}
          title={"E-Screen"}
          disabled={disabled}
          userRoles={userRoles}
          {...props}
        />
      </div>
      <div className={styles["flexRow"]}>
        <Required
          required={missingFields.some(
            field => field?.name === "enforcementActivity"
          )}
          message={
            missingFields.find(field => field?.name === "enforcementActivity")
              ?.error
          }
        >
          <SingleDropDown
            title={"Enforcement\xa0Activity"}
            value={enforcementActivity}
            options={enforcementActivities}
            stateName={"SET_ENFORCEMENT_ACTIVITY"}
            handleChange={e =>
              handleChange(e.target.value, "UPDATE_PROPERTY", {
                property: "enforcementActivity",
              })
            }
            userRoles={userRoles}
            classStyle={null}
            inputLabel={inputLabel}
            labelWidth={labelWidth}
            disabled={disabled}
            {...props}
          />
        </Required>
        <Required
          required={missingFields.some(
            field => field?.name === "weightMethods"
          )}
          message={
            missingFields.find(field => field?.name === "weightMethods")?.error
          }
        >
          <MultiDropDownObjects
            id={"weightMethods"}
            data-cy={"weightMethods"}
            title={"Weight\xa0Method"}
            stateName={"weightMethods"}
            handleChange={e =>
              handleChange(e.target.value, "UPDATE_PROPERTY", {
                property: "weightMethods",
              })
            }
            selectedValues={
              weightMethods
                ? weightMethodss?.filter(option =>
                    weightMethods?.some(swe => option.id === swe.id)
                  )
                : []
            }
            options={weightMethodss}
            formStyle={classes.formControl}
            labelStyle={classes.multiInputLabel}
            selectStyle={null}
            chipsStyle={styles["flexColumn"]}
            chipStyle={classes.chip}
            userRoles={userRoles}
            disabled={disabled}
            {...props}
          />
        </Required>
        <WeightMethodTotals
          show={enforcementActivity?.name === "Fixed Site"}
          dispatch={dispatch}
          state={state}
          handleChange={handleChange}
          weightMethods={weightMethods}
          disabled={disabled}
        />
      </div>
      <CollapsingHeader nightMode={nightMode} title={"Inspections"}>
        <div className={styles["flexRow"]}>
          <NumberField
            width={"150px"}
            maxLength={3}
            label={"#\xa0Size\xa0Permits\xa0Checked"}
            value={sizePermitsChecked}
            dispatch={dispatch}
            property={"sizePermitsChecked"}
            handleBlur={handleChange}
            variant={"outlined"}
            disabled={disabled}
          />
          <NumberField
            width={"150px"}
            maxLength={3}
            label={"#\xa0Weight\xa0Permits\xa0Checked"}
            value={weightPermitsChecked}
            dispatch={dispatch}
            property={"weightPermitsChecked"}
            handleBlur={handleChange}
            variant={"outlined"}
            disabled={disabled}
          />
          <NumberField
            width={"150px"}
            maxLength={3}
            label={"#\xa0CMVs\xa0Checked"}
            value={cmvsChecked}
            dispatch={dispatch}
            property={"cmvsChecked"}
            handleBlur={handleChange}
            variant={"outlined"}
            disabled={disabled}
          />
          <NumberField
            width={"150px"}
            maxLength={3}
            label={"#\xa0CVSA\xa0Decals\xa0Issued"}
            value={cvsaDecalsIssued}
            dispatch={dispatch}
            property={"cvsaDecalsIssued"}
            handleBlur={handleChange}
            variant={"outlined"}
            disabled={disabled}
          />
          <NumberField
            width={"150px"}
            maxLength={3}
            label={"#\xa0Supervised\xa0Inspections"}
            value={supervisedInspections}
            dispatch={dispatch}
            property={"supervisedInspections"}
            handleBlur={handleChange}
            variant={"outlined"}
            disabled={disabled}
          />
        </div>
        <div className={styles["flexRow"]}>
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa01\xa0Inspections"}
            value={lv1Inspections}
            dispatch={dispatch}
            property={"lv1Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa02\xa0Inspections"}
            value={lv2Inspections}
            dispatch={dispatch}
            property={"lv2Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa03\xa0Inspections"}
            value={lv3Inspections}
            dispatch={dispatch}
            property={"lv3Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa04\xa0Inspections"}
            value={lv4Inspections}
            dispatch={dispatch}
            property={"lv4Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa05\xa0Inspections"}
            value={lv5Inspections}
            dispatch={dispatch}
            property={"lv5Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa06\xa0Inspections"}
            value={lv6Inspections}
            dispatch={dispatch}
            property={"lv6Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa07\xa0Inspections"}
            value={lv7Inspections}
            dispatch={dispatch}
            property={"lv7Inspections"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa08\xa0Inspections"}
            value={lv8Inspections}
            dispatch={dispatch}
            property={"lv8Inspections"}
            handleBlur={handleChange}
          />
        </div>
        <div className={styles["flexRow"]}>
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa01\xa0Hazmat\xa0Inspections"}
            value={lv1HazmatInspections}
            dispatch={dispatch}
            property={"lv1HazmatInspections"}
            handleBlur={handleChange}
            width={"150px"}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa02\xa0Hazmat\xa0Inspections"}
            value={lv2HazmatInspections}
            dispatch={dispatch}
            property={"lv2HazmatInspections"}
            handleBlur={handleChange}
            width={"150px"}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa04\xa0Hazmat\xa0Inspections"}
            value={lv4HazmatInspections}
            dispatch={dispatch}
            property={"lv4HazmatInspections"}
            handleBlur={handleChange}
            width={"150px"}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0LV\xa05\xa0Hazmat\xa0Inspections"}
            value={lv5HazmatInspections}
            dispatch={dispatch}
            property={"lv5HazmatInspections"}
            handleBlur={handleChange}
            width={"150px"}
          />
        </div>
      </CollapsingHeader>
      <CollapsingHeader nightMode={nightMode} title={"Violations"}>
        <div className={styles["flexRow"]}>
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0Driver\xa0Violations"}
            value={driverViolations}
            dispatch={dispatch}
            property={"driverViolations"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0Vehicle\xa0Violations"}
            value={vehicleViolations}
            dispatch={dispatch}
            property={"vehicleViolations"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0of\xa0OOS\xa0Drivers"}
            value={numberOosDrivers}
            dispatch={dispatch}
            property={"numberOosDrivers"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0of\xa0OOS\xa0Vehicles"}
            value={numberOosVehicles}
            dispatch={dispatch}
            property={"numberOosVehicles"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0of\xa0Arrests"}
            value={numberArrests}
            dispatch={dispatch}
            property={"numberArrests"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"#\xa0VCVCs\xa0Issued"}
            value={numberVcvcsIssued}
            dispatch={dispatch}
            property={"numberVcvcsIssued"}
            handleBlur={handleChange}
          />
          <NumberField
            variant={"outlined"}
            disabled={disabled}
            label={"Total\xa0in\xa0Fines"}
            value={fineTotal}
            dispatch={dispatch}
            property={"fineTotal"}
            handleBlur={handleChange}
            dollars={true}
          />
        </div>
      </CollapsingHeader>
    </div>
  );
};

export default InspectionSection;

const WeightMethodTotals = ({
  show,
  state,
  weightMethods = [],
  dispatch,
  handleChange,
  disabled,
}) => {
  if (!show) return null;

  //portableWeighsCount
  //platformWeighsCount
  //semiPortableWeighsCount
  //wimsWeighsCount
  //otherWeighsCount

  const nameMap = {
    Portable: "portableWeighsCount",
    "Semi Portable": "semiPortableWeighsCount",
    WIMS: "wimsWeighsCount",
    Platform: "platformWeighsCount",
    Other: "otherWeighsCount",
  };
  // let total = 0
  const total = weightMethods?.reduce(
    (acc, method) => acc + (+state[nameMap[method?.name]] ?? 0),
    0
  );
  //iterate over the array of weightMethods to create NumberFields with label as the weightMethod.name, the handleChange will pass the weight as the value and the index and the property as weightMethods
  return (
    <div className={styles["flexRow"]}>
      <div className={`${styles["flexColumn"]} ${styles["reset"]}`}>
        {weightMethods?.map((weightMethod, index) => {
          const property = nameMap[weightMethod?.name];
          const val = state[property] || "";
          // total = total + val
          return (
            <NumberField
              key={weightMethod.id}
              label={weightMethod.name.replace(" ", "\xa0") + "\xa0Weighs"}
              value={val}
              dispatch={dispatch}
              handleBlur={handleChange}
              action={"UPDATE_PROPERTY"}
              property={property}
              index={index}
              customClass={styles["spacer"]}
              disabled={disabled}
            />
          );
        })}
      </div>
      <TextField
        //value is a sum of the weightMethods array of objects weight property
        value={total ?? ""}
        label={"Total Weighs"}
        className={`${styles["flexColumn"]} ${styles["reset"]}`}
        inputProps={{ style: { width: "100px", textAlign: "center" } }}
        disabled={true}
      />
    </div>
  );
};
